import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LottiePlayer from "../components/animationPlayer";

const FAQSection = ({ faqs }) => {
  return (
    <Box sx={{ width: "80%", margin: "60px auto" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
        }}
      >
        <p className="section-heading">FAQs</p>
        <LottiePlayer animationPath={"/json/coursePage2.json"} />
      </Box>

      {faqs.map((faq, index) => (
        <Accordion
          key={index}
          disableGutters
          square={false}
          sx={{
            mb: 2,
            borderRadius: "12px",
            border: "1px solid #e0e0e0",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
            transition: "box-shadow 0.3s ease",
            "&:hover": {
              boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.1)",
            },
            "&.Mui-expanded": {
              boxShadow: "0px 6px 18px rgba(0, 0, 0, 0.12)",
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "#30b6c9" }} />}
            sx={{
              backgroundColor: "#f0f9fa",
              fontWeight: "600",
              px: 3,
              py: 2,
              borderRadius: "12px 12px 0 0",
            }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: {
                  xs: "14px", // extra-small screens (mobile)
                  sm: "16px", // small screens
                  md: "18px", // medium and above
                },
                color: "#333",
                fontFamily: "Inter, sans-serif",
              }}
            >
              {faq.question}
            </Typography>
          </AccordionSummary>

          <AccordionDetails
            sx={{
              backgroundColor: "#ffffff",
              px: 3,
              py: 2,
              borderTop: "1px solid #e0e0e0",
              borderRadius: "0 0 12px 12px",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: "#555",
                fontSize: "16px",
                lineHeight: 1.6,
                fontFamily: "Inter, sans-serif",
              }}
            >
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default FAQSection;
